import { useModal } from '@ebay/nice-modal-react';
import { ConfirmDialog } from './ConfirmDialog';
import type { ConfirmDialogProps, ConfirmDialogResult } from './ConfirmDialog';

export function useConfirm() {
  const modal = useModal(ConfirmDialog);
  return {
    confirm: (props: ConfirmDialogProps) =>
      modal.show(props) as Promise<ConfirmDialogResult>,
    hide: () => void modal.hide(),
  };
}
